import { auth, db } from '../src/firebase.js';
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

/**
 * Main Application Entry Point
 * 
 * React equivalent would be:
 * function App() {
 *   const [sidebarExpanded, setSidebarExpanded] = useState(false);
 *   
 *   return (
 *     <div className="main-container">
 *       <TopNav onLogoClick={() => setSidebarExpanded(!sidebarExpanded)} />
 *       <Sidebar isExpanded={sidebarExpanded} onToggle={setSidebarExpanded} />
 *       <ContentArea />
 *     </div>
 *   );
 * }
 */
import { Sidebar } from './components/Sidebar.js';
import { TopNav } from './components/TopNav.js';
import { Message } from './components/Message.js';
import { CartDrawer } from './components/CartDrawer.js';
import { Stream } from './components/Stream.js';
import { TiagoAI } from './components/TiagoAI.js';
import { ContentArea } from './components/ContentArea.js';
import { Cups } from './components/Cups.js';
import { Shop } from './components/Shop.js';
import { Fitness } from './components/Fitness.js';
import { Podcast } from './components/Podcast.js';
import { PodcastPage } from './components/PodcastPage.js';
import { getPodcastById } from './data/podcastData.js';
import { Clubs } from './components/Clubs.js';
import { Agency } from './components/Agency.js';
import { Invest } from './components/Invest.js';
import { FootballGirlReport } from './components/FootballGirlReport.js';
import { Newsletter } from './components/Newsletter.js';
import { Education } from './components/Education.js';
import { Books } from './components/Books.js';
import { AboutUs } from './components/AboutUs.js';
import { ContactUs } from './components/ContactUs.js';
import { Profile } from './components/Profile.js';
import { PaymentSuccess } from './components/PaymentSuccess.js';
import { PaymentCancel } from './components/PaymentCancel.js';
import { Returns } from './components/Returns.js';
import { OrderConfirmation } from './components/OrderConfirmation.js';
import { Terms } from './components/Terms.js';
import { Login } from './components/Login.js';
import { Onboarding } from './components/Onboarding.js';
import { Settings } from './components/Settings.js';
import { SignOut } from './components/SignOut.js';
import { Leagues } from './components/Leagues.js';
import { NotFound } from './components/NotFound.js';
import { Fund } from './components/Fund.js';
import { Games } from './components/Games.js';
import { initMathBrainTrainer } from './components/MathBrainTrainer.js';
import { ProductDetail } from './components/ProductDetail.js';
import { ArticlePageWSL1 } from './components/ArticlePageWSL1.js';
import { ArticlePageWSL2 } from './components/ArticlePageWSL2.js';
import { ArticlePageWSL3 } from './components/ArticlePageWSL3.js';
import { ArticlePageWSL4 } from './components/ArticlePageWSL4.js';
import { ArticlePageWSL5 } from './components/ArticlePageWSL5.js';
import { ArticlePageWSL6 } from './components/ArticlePageWSL6.js';
import { ArticlePageWSL7 } from './components/ArticlePageWSL7.js';
import { ArticlePageWSL8 } from './components/ArticlePageWSL8.js';
import { ArticlePageWSL9 } from './components/ArticlePageWSL9.js';
import { ArticlePageNWSL1 } from './components/ArticlePageNWSL1.js';
import { ArticlePageNWSL2 } from './components/ArticlePageNWSL2.js';
import { ArticlePageNWSL3 } from './components/ArticlePageNWSL3.js';
import { ArticlePageNWSL4 } from './components/ArticlePageNWSL4.js';
import { ArticlePageNWSL5 } from './components/ArticlePageNWSL5.js';
import { ArticlePageNWSL6 } from './components/ArticlePageNWSL6.js';
import { ArticlePageNWSL7 } from './components/ArticlePageNWSL7.js';
import { ArticlePageNWSL8 } from './components/ArticlePageNWSL8.js';
import { ArticlePageNWSL9 } from './components/ArticlePageNWSL9.js';
import { ArticlePage2 } from './components/ArticlePage2.js';
import { ArticlePageAPL1 } from './components/ArticlePageAPL1.js';
import { ArticlePageAPL2 } from './components/ArticlePageAPL2.js';
import { ArticlePageAPL3 } from './components/ArticlePageAPL3.js';
import { ArticlePageAPL4 } from './components/ArticlePageAPL4.js';
import { ArticlePageAPL5 } from './components/ArticlePageAPL5.js';
import { ArticlePageAPL6 } from './components/ArticlePageAPL6.js';
import { ArticlePageAPL7 } from './components/ArticlePageAPL7.js';
import { ArticlePageAPL8 } from './components/ArticlePageAPL8.js';
import { ArticlePageAPL9 } from './components/ArticlePageAPL9.js';
import { ArticlePageDFB1 } from './components/ArticlePageDFB1.js';
import { ArticlePageDFB2 } from './components/ArticlePageDFB2.js';
import { ArticlePageDFB3 } from './components/ArticlePageDFB3.js';
import { ArticlePageDFB4 } from './components/ArticlePageDFB4.js';
import { ArticlePageDFB5 } from './components/ArticlePageDFB5.js';
import { ArticlePageDFB6 } from './components/ArticlePageDFB6.js';
import { ArticlePageDFB7 } from './components/ArticlePageDFB7.js';
import { ArticlePageDFB8 } from './components/ArticlePageDFB8.js';
import { ArticlePageDFB9 } from './components/ArticlePageDFB9.js';
import { ArticlePageLIGAF1 } from './components/ArticlePageLIGAF1.js';
import { ArticlePageLIGAF2 } from './components/ArticlePageLIGAF2.js';
import { ArticlePageLIGAF3 } from './components/ArticlePageLIGAF3.js';
import { ArticlePageLIGAF4 } from './components/ArticlePageLIGAF4.js';
import { ArticlePageLIGAF5 } from './components/ArticlePageLIGAF5.js';
import { ArticlePageLIGAF6 } from './components/ArticlePageLIGAF6.js';
import { ArticlePageLIGAF7 } from './components/ArticlePageLIGAF7.js';
import { ArticlePageLIGAF8 } from './components/ArticlePageLIGAF8.js';
import { ArticlePageLIGAF9 } from './components/ArticlePageLIGAF9.js';
import { ArticlePageSERIEA1 } from './components/ArticlePageSERIEA1.js';
import { ArticlePageSERIEA2 } from './components/ArticlePageSERIEA2.js';
import { ArticlePageSERIEA3 } from './components/ArticlePageSERIEA3.js';
import { ArticlePageSERIEA4 } from './components/ArticlePageSERIEA4.js';
import { ArticlePageSERIEA5 } from './components/ArticlePageSERIEA5.js';
import { ArticlePageSERIEA6 } from './components/ArticlePageSERIEA6.js';
import { ArticlePageSERIEA7 } from './components/ArticlePageSERIEA7.js';
import { ArticlePageSERIEA8 } from './components/ArticlePageSERIEA8.js';
import { ArticlePageSERIEA9 } from './components/ArticlePageSERIEA9.js';
import { ArticlePageWK1 } from './components/ArticlePageWK1.js';
import { ArticlePageWK2 } from './components/ArticlePageWK2.js';
import { ArticlePageWK3 } from './components/ArticlePageWK3.js';
import { ArticlePageWK4 } from './components/ArticlePageWK4.js';
import { ArticlePageWK5 } from './components/ArticlePageWK5.js';
import { ArticlePageWK6 } from './components/ArticlePageWK6.js';
import { ArticlePageWK7 } from './components/ArticlePageWK7.js';
import { ArticlePageWK8 } from './components/ArticlePageWK8.js';
import { ArticlePageWK9 } from './components/ArticlePageWK9.js';
import { ArticlePageBPI1 } from './components/ArticlePageBPI1.js';
import { ArticlePageBPI2 } from './components/ArticlePageBPI2.js';
import { ArticlePageBPI3 } from './components/ArticlePageBPI3.js';
import { ArticlePageBPI4 } from './components/ArticlePageBPI4.js';
import { ArticlePageBPI5 } from './components/ArticlePageBPI5.js';
import { ArticlePageBPI6 } from './components/ArticlePageBPI6.js';
import { ArticlePageBPI7 } from './components/ArticlePageBPI7.js';
import { ArticlePageBPI8 } from './components/ArticlePageBPI8.js';
import { ArticlePageBPI9 } from './components/ArticlePageBPI9.js';
import { ArticlePageBRASIL1 } from './components/ArticlePageBRASIL1.js';
import { ArticlePageBRASIL2 } from './components/ArticlePageBRASIL2.js';
import { ArticlePageBRASIL3 } from './components/ArticlePageBRASIL3.js';
import { ArticlePageBRASIL4 } from './components/ArticlePageBRASIL4.js';
import { ArticlePageBRASIL5 } from './components/ArticlePageBRASIL5.js';
import { ArticlePageBRASIL6 } from './components/ArticlePageBRASIL6.js';
import { ArticlePageBRASIL7 } from './components/ArticlePageBRASIL7.js';
import { ArticlePageBRASIL8 } from './components/ArticlePageBRASIL8.js';
import { ArticlePageBRASIL9 } from './components/ArticlePageBRASIL9.js';
import { ArticlePageLIGAMX1 } from './components/ArticlePageLIGAMX1.js';
import { ArticlePageLIGAMX2 } from './components/ArticlePageLIGAMX2.js';
import { ArticlePageLIGAMX3 } from './components/ArticlePageLIGAMX3.js';
import { ArticlePageLIGAMX4 } from './components/ArticlePageLIGAMX4.js';
import { ArticlePageLIGAMX5 } from './components/ArticlePageLIGAMX5.js';
import { ArticlePageLIGAMX6 } from './components/ArticlePageLIGAMX6.js';
import { ArticlePageLIGAMX7 } from './components/ArticlePageLIGAMX7.js';
import { ArticlePageLIGAMX8 } from './components/ArticlePageLIGAMX8.js';
import { ArticlePageLIGAMX9 } from './components/ArticlePageLIGAMX9.js';
import { ArticlePageNWFL1 } from './components/ArticlePageNWFL1.js';
import { ArticlePageNWFL2 } from './components/ArticlePageNWFL2.js';
import { ArticlePageNWFL3 } from './components/ArticlePageNWFL3.js';
import { ArticlePageNWFL4 } from './components/ArticlePageNWFL4.js';
import { ArticlePageNWFL5 } from './components/ArticlePageNWFL5.js';
import { ArticlePageNWFL6 } from './components/ArticlePageNWFL6.js';
import { ArticlePageNWFL7 } from './components/ArticlePageNWFL7.js';
import { ArticlePageNWFL8 } from './components/ArticlePageNWFL8.js';
import { ArticlePageNWFL9 } from './components/ArticlePageNWFL9.js';
import { ArticlePageUSL1 } from './components/ArticlePageUSL1.js';
import { ArticlePageUSL2 } from './components/ArticlePageUSL2.js';
import { ArticlePageUSL3 } from './components/ArticlePageUSL3.js';
import { ArticlePageUSL4 } from './components/ArticlePageUSL4.js';
import { ArticlePageUSL5 } from './components/ArticlePageUSL5.js';
import { ArticlePageUSL6 } from './components/ArticlePageUSL6.js';
import { ArticlePageUSL7 } from './components/ArticlePageUSL7.js';
import { ArticlePageUSL8 } from './components/ArticlePageUSL8.js';
import { ArticlePageUSL9 } from './components/ArticlePageUSL9.js';
import { ArticlePageWE1 } from './components/ArticlePageWE1.js';
import { ArticlePageWE2 } from './components/ArticlePageWE2.js';
import { ArticlePageWE3 } from './components/ArticlePageWE3.js';
import { ArticlePageWE4 } from './components/ArticlePageWE4.js';
import { ArticlePageWE5 } from './components/ArticlePageWE5.js';
import { ArticlePageWE6 } from './components/ArticlePageWE6.js';
import { ArticlePageWE7 } from './components/ArticlePageWE7.js';
import { ArticlePageWE8 } from './components/ArticlePageWE8.js';
import { ArticlePageWE9 } from './components/ArticlePageWE9.js';
import { ArticlePageSAFF1 } from './components/ArticlePageSAFF1.js';
import { ArticlePageSAFF2 } from './components/ArticlePageSAFF2.js';
import { ArticlePageSAFF3 } from './components/ArticlePageSAFF3.js';
import { ArticlePageSAFF4 } from './components/ArticlePageSAFF4.js';
import { ArticlePageSAFF5 } from './components/ArticlePageSAFF5.js';
import { ArticlePageSAFF6 } from './components/ArticlePageSAFF6.js';
import { ArticlePageSAFF7 } from './components/ArticlePageSAFF7.js';
import { ArticlePageSAFF8 } from './components/ArticlePageSAFF8.js';
import { ArticlePageSAFF9 } from './components/ArticlePageSAFF9.js';
import { ArticlePageSWEDEN1 } from './components/ArticlePageSWEDEN1.js';
import { ArticlePageSWEDEN2 } from './components/ArticlePageSWEDEN2.js';
import { ArticlePageSWEDEN3 } from './components/ArticlePageSWEDEN3.js';
import { ArticlePageSWEDEN4 } from './components/ArticlePageSWEDEN4.js';
import { ArticlePageSWEDEN5 } from './components/ArticlePageSWEDEN5.js';
import { ArticlePageSWEDEN6 } from './components/ArticlePageSWEDEN6.js';
import { ArticlePageSWEDEN7 } from './components/ArticlePageSWEDEN7.js';
import { ArticlePageSWEDEN8 } from './components/ArticlePageSWEDEN8.js';
import { ArticlePageSWEDEN9 } from './components/ArticlePageSWEDEN9.js';
import { ArticlePageALEAGUE1 } from './components/ArticlePageALEAGUE1.js';
import { ArticlePageALEAGUE2 } from './components/ArticlePageALEAGUE2.js';
import { ArticlePageALEAGUE3 } from './components/ArticlePageALEAGUE3.js';
import { ArticlePageALEAGUE4 } from './components/ArticlePageALEAGUE4.js';
import { ArticlePageALEAGUE5 } from './components/ArticlePageALEAGUE5.js';
import { ArticlePageALEAGUE6 } from './components/ArticlePageALEAGUE6.js';
import { ArticlePageALEAGUE7 } from './components/ArticlePageALEAGUE7.js';
import { ArticlePageALEAGUE8 } from './components/ArticlePageALEAGUE8.js';
import { ArticlePageALEAGUE9 } from './components/ArticlePageALEAGUE9.js';
import { isAuthenticated, onAuthStateChanged as authOnAuthStateChanged, getCurrentUser } from './data/auth.js'; // Import auth helpers
import { ArticlePageWORLD1 } from './components/ArticlePageWORLD1.js';
import { ArticlePageWORLD2 } from './components/ArticlePageWORLD2.js';
import { ArticlePageWORLD3 } from './components/ArticlePageWORLD3.js';
import { ArticlePageWORLD4 } from './components/ArticlePageWORLD4.js';
import { ArticlePageWORLD5 } from './components/ArticlePageWORLD5.js';
import { ArticlePageWORLD6 } from './components/ArticlePageWORLD6.js';
import { ArticlePageWORLD7 } from './components/ArticlePageWORLD7.js';
import { ArticlePageWORLD8 } from './components/ArticlePageWORLD8.js';
import { ArticlePageWORLD9 } from './components/ArticlePageWORLD9.js';

class App {
    // ... (constructor and init methods remain largely the same)
    constructor() {
        this.sidebar = null;
        this.topNav = null;
        this.contentArea = null;
        this.cartDrawer = null;
        this.currentPageInstance = null;
        this.currentUser = null;
        this.cart = [];
        
        this.authReady = false;
        this.authReadyPromise = new Promise(resolve => {
            this.resolveAuth = resolve;
        });
        
        // Setup Global Auth Listener (using Firebase SDK directly here for initial app setup)
        authOnAuthStateChanged(async (user) => { // Use the helper from auth.js
            if (!this.authReady) {
                this.authReady = true;
                if (this.resolveAuth) this.resolveAuth();
            }
            if (user) {
                console.log("FootballGirl User is logged in:", user.email);
                // Load user preferences (Dark Mode) immediately
                getDoc(doc(db, "users", user.uid)).then((snap) => {
                    if (snap.exists() && snap.data().darkMode) {
                        document.body.setAttribute('data-theme', 'dark');
                    }
                });
            } else {
                console.log("No user logged in.");
            }
            this.currentUser = user; // Store the simplified user object
            if (this.topNav) await this.topNav.updateAuthState(user); // Await updateAuthState
        });
    }

    /**
     * Initialize the application
     * Similar to React's componentDidMount or useEffect
     */
    async init() {
        try {
            console.log('🚀 App.init() called - Pure JS Mode');
            // Small delay to ensure DOM is ready
            await new Promise(resolve => setTimeout(resolve, 100));

            // Inject Dark Mode Styles
            this.injectGlobalTheme();
            this.injectUnsavedChangesModalStyles();
            
            // Initialize component instances
            console.log('⚙️ Initializing component instances...');
            await this.initializeComponents();
            console.log('✅ Component instances initialized');

            this.checkHashNavigation();
            window.addEventListener('hashchange', () => this.checkHashNavigation());
            
            console.log('🎉 App initialized successfully');
            
            // Hide loading message
            const errorDiv = document.getElementById('error-message');
            if (errorDiv) {
                errorDiv.style.display = 'none';
            }
        } catch (error) {
            console.error('❌ Failed to initialize app:', error);
            console.error('Error details:', {
                message: error.message,
                stack: error.stack,
                name: error.name
            });
            throw error; // Re-throw to show in UI
        }
    }

    /**
     * Injects global CSS variables and Dark Mode overrides.
     * This ensures the theme works across the app without modifying styles.css directly.
     */
    injectGlobalTheme() {
        const styleId = 'fg-global-theme';
        if (document.getElementById(styleId)) return;

        const css = `
            :root {
                --bg-color: #ffffff;
                --text-color: #333333;
                --text-secondary: #666666;
                --card-bg: #ffffff;
                --border-color: #e5e5e5;
                --nav-bg: #ffffff;
                --sidebar-bg: #f5f6f8;
                --input-bg: #ffffff;
                --hover-bg: #f5f6f8;
            }

            [data-theme="dark"] {
                --bg-color: #18191a;
                --text-color: #e4e6eb;
                --text-secondary: #b0b3b8;
                --card-bg: #242526;
                --border-color: #3e4042;
                --nav-bg: #242526;
                --sidebar-bg: #18191a;
                --input-bg: #3a3b3c;
                --hover-bg: #3a3b3c;
                --surface-1: #242526;
                --surface-2: #3a3b3c;
                --text-muted: #b0b3b8;
                --border-light: #3e4042;
            }

            body {
                background-color: var(--bg-color);
                color: var(--text-color);
                transition: background-color 0.3s, color 0.3s;
            }

            /* Component Overrides for Dark Mode */
            [data-theme="dark"] .fg-profile-card,
            [data-theme="dark"] .fg-card,
            [data-theme="dark"] .fg-form-card,
            [data-theme="dark"] .fg-settings,
            [data-theme="dark"] .news-card, 
            [data-theme="dark"] .podcast-card,
            [data-theme="dark"] .fg-cup-card,
            [data-theme="dark"] .fg-product-card,
            [data-theme="dark"] .fg-game-card {
                background-color: var(--card-bg);
                color: var(--text-color);
                border-color: var(--border-color);
            }

            [data-theme="dark"] .fg-page__header,
            [data-theme="dark"] .fg-page__title {
                color: var(--text-color);
            }

            [data-theme="dark"] #sidebar {
                background-color: var(--sidebar-bg);
                border-right: 1px solid var(--border-color);
                color: var(--text-color);
            }
            
            [data-theme="dark"] .nav-item:hover {
                background-color: var(--hover-bg);
            }

            /* Dark Mode - Article Cards */
            [data-theme="dark"] .news-card {
                background-color: var(--surface-1);
            }
            [data-theme="dark"] .news-card .card-headline {
                color: var(--text-color);
            }
            [data-theme="dark"] .news-card .card-meta {
                color: var(--text-muted);
            }

            /* Dark Mode - Article Pages */
            [data-theme="dark"] .article-view,
            [data-theme="dark"] .comments-section,
            [data-theme="dark"] .footer-card {
                background-color: var(--bg-color);
                color: var(--text-color);
            }
            [data-theme="dark"] .article-title,
            [data-theme="dark"] .article-content,
            [data-theme="dark"] .comments-header,
            [data-theme="dark"] .comment-author,
            [data-theme="dark"] .comment-text,
            [data-theme="dark"] .footer-card-text {
                color: var(--text-color);
            }
            [data-theme="dark"] .article-meta,
            [data-theme="dark"] .comment-meta {
                color: var(--text-muted);
            }
            [data-theme="dark"] .tag-pill {
                background-color: var(--surface-2);
                color: var(--text-color);
            }
            [data-theme="dark"] .share-icon,
            [data-theme="dark"] .nav-arrow-btn,
            [data-theme="dark"] .comment-avatar {
                background-color: var(--surface-2);
                color: var(--text-color);
            }
            [data-theme="dark"] .share-icon:hover,
            [data-theme="dark"] .nav-arrow-btn:hover {
                background-color: var(--border-light);
            }
            [data-theme="dark"] .comment-form-container,
            [data-theme="dark"] .auth-prompt,
            [data-theme="dark"] .footer-card {
                background-color: var(--surface-1);
            }
            [data-theme="dark"] .comment-textarea {
                background-color: var(--input-bg);
                border-color: var(--border-light);
                color: var(--text-color);
            }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    injectUnsavedChangesModalStyles() {
        const styleId = 'fg-unsaved-changes-styles';
        if (document.getElementById(styleId)) return;
        const css = `
            .fg-confirm-modal { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 20000; display: none; align-items: center; justify-content: center; padding: 20px; }
            .fg-confirm-modal.is-open { display: flex; }
            .fg-confirm-card { background: #fff; border-radius: 16px; padding: 32px; max-width: 400px; width: 100%; box-shadow: 0 20px 40px rgba(0,0,0,0.2); text-align: center; }
            .fg-confirm-card h3 { font-size: 1.25rem; font-weight: 800; margin-bottom: 12px; color: #000; }
            .fg-confirm-card p { color: #65676b; font-size: 0.95rem; line-height: 1.5; margin-bottom: 24px; }
            .fg-confirm-actions { display: flex; flex-direction: column; gap: 12px; }
            [data-theme="dark"] .fg-confirm-card { background: #242526; }
            [data-theme="dark"] .fg-confirm-card h3 { color: #fff; }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);

        const modalHtml = `
            <div class="fg-confirm-modal" id="unsaved-changes-modal">
                <div class="fg-confirm-card">
                    <h3>Discard and save Changes?</h3>
                    <p>You have unsaved modifications on this page. Would you like to save them before leaving?</p>
                    <div class="fg-confirm-actions">
                        <button class="fg-btn fg-btn--primary" id="confirm-save">Save and Continue</button>
                        <button class="fg-btn" id="confirm-discard" style="border-color: #ddd; color: #666;">Discard Changes</button>
                        <button class="fg-btn" id="confirm-cancel" style="border: none;">Stay on Page</button>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }

    showUnsavedChangesModal(onSave, onDiscard, onCancel) {
        const modal = document.getElementById('unsaved-changes-modal');
        if (!modal) return;
        modal.classList.add('is-open');
        
        const close = () => modal.classList.remove('is-open');

        modal.querySelector('#confirm-save').onclick = () => { close(); onSave(); };
        modal.querySelector('#confirm-discard').onclick = () => { close(); onDiscard(); };
        modal.querySelector('#confirm-cancel').onclick = () => { close(); onCancel(); };
    }

    performNavigation(detail) {
        const { page, projectId, productId, session_id } = detail;

        // Map sub-pages to parent navigation categories for highlighting
        let activeNavId = page;
        const fundingPages = [
            'fund', 'crowdfunding-create', 'crowdfunding-create-2', 'crowdfunding-detail',
            'project-dashboard', 'project-basics', 'project-story', 'project-funding',
            'project-rewards', 'project-preferences', 'project-plan', 'project-people', 
            'project-payment', 'my-launches', 'creator-profile', 'creator-onboarding'
        ];

        if (fundingPages.includes(page)) {
            activeNavId = 'fund';
        }

        if (this.topNav) {
            this.topNav.setActive(activeNavId);
        }

        const container = document.getElementById('app-content');
        if (!container) return;

        container.classList.add('fg-page--fading');

        setTimeout(() => {
            // Clean up previous page instance to prevent memory leaks and zombie renders
            if (this.currentPageInstance && typeof this.currentPageInstance.destroy === 'function') {
                this.currentPageInstance.destroy();
            }

            container.innerHTML = '';
            
            // Centralized Routing Logic
            if (page === 'login') {
                this.currentPageInstance = new Login('app-content');
                this.currentPageInstance.init();
            } else if (page === 'profile') {
                this.currentPageInstance = new Profile('app-content');
                this.currentPageInstance.init();
            } else if (page === 'home') {
                this.currentPageInstance = new ContentArea('app-content', {
                    rows: 17,
                    onCardClick: (cardIndex) => this.handleArticleNavigation(cardIndex)
                });
                this.currentPageInstance.init();
            } else if (page === 'project-dashboard') {
                import('./components/ProjectDashboard.js').then(({ ProjectDashboard }) => {
                    this.currentPageInstance = new ProjectDashboard('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-basics') {
                import('./components/ProjectBasics.js').then(({ ProjectBasics }) => {
                    this.currentPageInstance = new ProjectBasics('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-story') {
                import('./components/ProjectStory.js').then(({ ProjectStory }) => {
                    this.currentPageInstance = new ProjectStory('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-funding') {
                import('./components/ProjectFunding.js').then(({ ProjectFunding }) => {
                    this.currentPageInstance = new ProjectFunding('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-rewards') {
                import('./components/ProjectRewards.js').then(({ ProjectRewards }) => {
                    this.currentPageInstance = new ProjectRewards('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-preferences') {
                import('./components/ProjectPreferences.js').then(({ ProjectPreferences }) => {
                    this.currentPageInstance = new ProjectPreferences('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-plan') {
                import('./components/ProjectPlan.js').then(({ ProjectPlan }) => {
                    this.currentPageInstance = new ProjectPlan('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-people') {
                import('./components/ProjectPeople.js').then(({ ProjectPeople }) => {
                    this.currentPageInstance = new ProjectPeople('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'project-payment') {
                import('./components/ProjectPayment.js').then(({ ProjectPayment }) => {
                    this.currentPageInstance = new ProjectPayment('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'help') {
                import('./components/HelpCenter.js').then(({ HelpCenter }) => {
                    this.currentPageInstance = new HelpCenter('app-content');
                    this.currentPageInstance.init();
                });
            } else if (page === 'creator-profile') {
                import('./components/CreatorProfile.js').then(({ CreatorProfile }) => {
                    this.currentPageInstance = new CreatorProfile('app-content');
                    this.currentPageInstance.init();
                });
            } else if (page === 'creator-saved-projects') {
                import('./components/CreatorSavedProjects.js').then(({ CreatorSavedProjects }) => {
                    this.currentPageInstance = new CreatorSavedProjects('app-content');
                    this.currentPageInstance.init();
                });
            } else if (page === 'shop') {
                this.currentPageInstance = new Shop('app-content');
                this.currentPageInstance.init();
            } else if (page === 'product-detail') {
                this.currentPageInstance = new ProductDetail('app-content', productId);
                this.currentPageInstance.init();
            } else if (page === 'order-confirmation') {
                this.currentPageInstance = new OrderConfirmation('app-content', session_id);
                this.currentPageInstance.init();
            } else if (page === 'success') {
                this.currentPageInstance = new PaymentSuccess('app-content', session_id);
                this.currentPageInstance.init();
            } else if (page === 'cancel') {
                this.currentPageInstance = new PaymentCancel('app-content');
                this.currentPageInstance.init();
            } else if (page === 'fund') {
                this.currentPageInstance = new Fund('app-content');
                this.currentPageInstance.init();
            } else if (page === 'crowdfunding-detail') {
                import('./components/CrowdfundingDetail.js').then(({ CrowdfundingDetail }) => {
                    this.currentPageInstance = new CrowdfundingDetail('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'crowdfunding-create') {
                import('./components/CrowdfundingCreate.js').then(({ CrowdfundingCreate }) => {
                    this.currentPageInstance = new CrowdfundingCreate('app-content');
                    this.currentPageInstance.init();
                });
            } else if (page === 'crowdfunding-create-2') {
                import('./components/CrowdfundingCreate2.js').then(({ CrowdfundingCreate2 }) => {
                    this.currentPageInstance = new CrowdfundingCreate2('app-content', projectId);
                    this.currentPageInstance.init();
                });
            } else if (page === 'onboarding') {
                this.currentPageInstance = new Onboarding('app-content');
                this.currentPageInstance.init();
            } else if (page === 'settings') {
                this.currentPageInstance = new Settings('app-content');
                this.currentPageInstance.init();
            } else if (page === 'message') {
                this.currentPageInstance = new Message('app-content');
                this.currentPageInstance.init();
            } else if (page === 'tiago-ai') {
                this.currentPageInstance = new TiagoAI('app-content');
                this.currentPageInstance.init();
            } else if (page === 'stream') {
                this.currentPageInstance = new Stream('app-content');
                this.currentPageInstance.init();
            } else if (page === 'cups') {
                this.currentPageInstance = new Cups('app-content');
                this.currentPageInstance.init();
            } else if (page === 'fc-robo-report') {
                // Placeholder for the footballgirl Q1 Report component
                container.innerHTML = '<div style="padding: 100px; text-align: center;"><h2>Loading Q1 Report...</h2></div>';
                window.scrollTo(0, 0);
            } else if (page === 'fitness') {
                this.currentPageInstance = new Fitness('app-content');
                this.currentPageInstance.init();
            } else if (page === 'podcast') {
                this.currentPageInstance = new Podcast('app-content', { 
                    onPodcastClick: (id) => this.showPodcastDetail(id) 
                });
                this.currentPageInstance.init();
            } else if (page === 'clubs') {
                this.currentPageInstance = new Clubs('app-content');
                this.currentPageInstance.init();
            } else if (page === 'footballgirl-report') {
                this.currentPageInstance = new FootballGirlReport('app-content');
                this.currentPageInstance.init();
            } else if (page === 'fc-robo-report') {
                // Placeholder for the footballgirl Q1 Report component
                container.innerHTML = '<div style="padding: 100px; text-align: center;"><h2>Loading Q1 Report...</h2></div>';
                window.scrollTo(0, 0);
            } else if (page === 'agency') {
                this.currentPageInstance = new Agency('app-content');
                this.currentPageInstance.init();
            } else if (page === 'invest') {
                this.currentPageInstance = new Invest('app-content');
                this.currentPageInstance.init();
            } else if (page === 'newsletter') {
                this.currentPageInstance = new Newsletter('app-content');
                this.currentPageInstance.init();
            } else if (page === 'education') {
                this.currentPageInstance = new Education('app-content');
                this.currentPageInstance.init();
            } else if (page === 'books') {
                this.currentPageInstance = new Books('app-content');
                this.currentPageInstance.init();
            } else if (page === 'about-us') {
                this.currentPageInstance = new AboutUs('app-content');
                this.currentPageInstance.init();
            } else if (page === 'contact-us') {
                this.currentPageInstance = new ContactUs('app-content');
                this.currentPageInstance.init();
            } else if (page === 'leagues') {
                this.currentPageInstance = new Leagues('app-content');
                this.currentPageInstance.init();
            } else if (page === 'fc-robo-report') {
                // Placeholder for the footballgirl Q1 Report component
                container.innerHTML = '<div style="padding: 60px; text-align: center;"><h2>Loading Q1 Report...</h2></div>';
                window.scrollTo(0, 0);
            } else if (page === 'games') {
                this.currentPageInstance = new Games('app-content');
                this.currentPageInstance.init();
            } else if (page === 'math-brain-trainer') {
                this.currentPageInstance = null;
                initMathBrainTrainer('app-content');
            } else if (page === 'sign-out') {
                this.currentPageInstance = new SignOut('app-content');
                this.currentPageInstance.init();
            } else if (page === 'returns') {
                this.currentPageInstance = new Returns('app-content');
                this.currentPageInstance.init();
            } else if (page === 'terms') {
                this.currentPageInstance = new Terms('app-content');
                this.currentPageInstance.init();
            } else {
                this.currentPageInstance = new NotFound('app-content');
                this.currentPageInstance.init();
            }

            window.scrollTo(0, 0);
            container.classList.remove('fg-page--fading');
        }, 150);
    }

    /**
     * Initialize component instances with their logic
     */
    async initializeComponents() {
        // Initialize Sidebar
        // Pass 'app-sidebar' to match index.html (though Sidebar currently appends to body)
        this.sidebar = new Sidebar('app-sidebar', {
            onToggle: (isExpanded) => {
                // Handle sidebar toggle
                console.log('Sidebar toggled:', isExpanded);
            },
            onItemClick: (itemId) => this.handleNavigation(itemId)
        });
        await this.sidebar.init();

        // Initialize TopNav
        // Pass 'app-header' to match index.html
        this.topNav = new TopNav('app-header', {
            onLogoClick: () => {
                // Toggle sidebar when logo is clicked
                if (this.sidebar) {
                    this.sidebar.toggle(); // This is for the main sidebar
                    this.topNav.setActive('home'); // Reset active state if sidebar is toggled
                }
            },
            onItemClick: (itemId, element) => {
                // Handle top nav item click
                console.log('Top nav item clicked:', itemId);
                this.handleNavigation(itemId);
            }
            , onBagClick: () => this.cartDrawer.toggle() // Pass the cart drawer toggle function
        });
        await this.topNav.init();

        // Initialize ContentArea
        this.contentArea = new ContentArea('app-content', {
            rows: 17,
            onCardClick: (cardIndex, element) => {
                // Handle news card click
                console.log('News card clicked:', cardIndex);
                this.handleArticleNavigation(cardIndex);
            }
        });
        await this.contentArea.init();

        this.cartDrawer = new CartDrawer();
        this.cartDrawer.init();

        // Handle back navigation from article
        document.getElementById('app-content').addEventListener('closeArticle', () => {
            this.handleNavigation('home');
            window.scrollTo(0, 0);
        });

        // Handle navigation to next article
        document.getElementById('app-content').addEventListener('navigateArticle', (e) => {
            if (e.detail && e.detail.index) {
                this.handleArticleNavigation(e.detail.index);
            }
        });

        // Handle navigation to home with anchor
        document.getElementById('app-content').addEventListener('navigateHome', (e) => {
            this.handleNavigation('home');
            if (e.detail && e.detail.anchor) {
                setTimeout(() => {
                    const el = document.getElementById(e.detail.anchor);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        });

        // Handle product detail navigation
        window.addEventListener('fg:navigate', (e) => {

            if (this.currentPageInstance && this.currentPageInstance.isDirty) {
                this.showUnsavedChangesModal(
                    () => { // Save and continue
                        const saveBtn = document.querySelector('.fg-btn--primary[id^="save-"], .fg-btn--primary[type="submit"]');
                        if (saveBtn) saveBtn.click();
                        setTimeout(() => this.performNavigation(e.detail), 500);
                    },
                    () => { // Discard and leave
                        this.currentPageInstance.isDirty = false;
                        this.performNavigation(e.detail);
                    },
                    () => { /* Cancel - do nothing */ }
                );
                return;
            }

            this.performNavigation(e.detail);
        });

        window.addEventListener('fg:addtocart', (e) => {
            const { product, size } = e.detail;
            const existing = this.cart.find(item => 
                item.product.id === product.id && item.size === size
            );
            if (existing) {
                existing.quantity += 1;
            } else {
                this.cart.push({ product, size, quantity: 1 });
            }
            const total = this.cart.reduce((sum, item) => sum + item.quantity, 0);
            window.dispatchEvent(new CustomEvent('fg:cartupdated', { 
                detail: { count: total, cart: this.cart } 
            }));
        });
    }

    getParamsFromHash() {
        const hash = window.location.hash.substring(1);
        const search = window.location.search.substring(1);
        
        const hashParams = Object.fromEntries(new URLSearchParams(hash).entries());
        const searchParams = Object.fromEntries(new URLSearchParams(search).entries());
        
        // Merge both, letting hash params take priority for 'page'
        return { ...searchParams, ...hashParams };
    }

    checkHashNavigation() {
        const params = this.getParamsFromHash();
        if (params.page) {
            window.dispatchEvent(new CustomEvent('fg:navigate', { 
                detail: { page: params.page, ...params } 
            }));
        }
    }

    /**
     * Handle navigation between views
     */
    async handleNavigation(itemId) {
        console.log('Navigating to:', itemId);
        
        // Unified logic: dispatch navigation event
        window.dispatchEvent(new CustomEvent('fg:navigate', { 
            detail: { page: itemId } 
        }));
    }

    /**
     * Shows the detail page for a specific podcast.
     * @param {string} podcastId - The ID of the podcast to display.
     */
    showPodcastDetail(podcastId) {
        const contentContainerId = 'app-content';
        const container = document.getElementById(contentContainerId);
        if (!container) return;

        container.innerHTML = ''; // Clear content

        const podcastData = getPodcastById(podcastId);
        if (podcastData) {
            const podcastPageComponent = new PodcastPage(contentContainerId, {
                podcast: podcastData,
                onBack: () => this.handleNavigation('podcast') // Navigate back to the grid
            });
            podcastPageComponent.init();
            window.scrollTo(0, 0);
        } else {
            console.error(`Podcast with id ${podcastId} not found.`);
            container.innerHTML = `<div style="padding: 2rem; text-align: center;">Error: Podcast not found.</div>`;
        }
    }

    /**
     * Handle navigation to article pages based on card index
     */
    handleArticleNavigation(id) {
        // Fix for World row ID mismatch (row-17-x -> world-x) due to caching
        if (id && id.startsWith('row-17-')) {
            id = id.replace('row-17-', 'world-');
            console.log('🔧 Auto-corrected ID to:', id);
        }

        const articleMap = {
            'wsl-1': ArticlePageWSL1,
            'wsl-2': ArticlePageWSL2,
            'wsl-3': ArticlePageWSL3,
            'wsl-4': ArticlePageWSL4,
            'wsl-5': ArticlePageWSL5,
            'wsl-6': ArticlePageWSL6,
            'wsl-7': ArticlePageWSL7,
            'wsl-8': ArticlePageWSL8,
            'wsl-9': ArticlePageWSL9,
            '2': ArticlePage2,
            'nwsl-1': ArticlePageNWSL1,
            'nwsl-2': ArticlePageNWSL2,
            'nwsl-3': ArticlePageNWSL3,
            'nwsl-4': ArticlePageNWSL4,
            'nwsl-5': ArticlePageNWSL5,
            'nwsl-6': ArticlePageNWSL6,
            'nwsl-7': ArticlePageNWSL7,
            'nwsl-8': ArticlePageNWSL8,
            'nwsl-9': ArticlePageNWSL9,
            'apl-1': ArticlePageAPL1,
            'apl-2': ArticlePageAPL2,
            'apl-3': ArticlePageAPL3,
            'apl-4': ArticlePageAPL4,
            'apl-5': ArticlePageAPL5,
            'apl-6': ArticlePageAPL6,
            'apl-7': ArticlePageAPL7,
            'apl-8': ArticlePageAPL8,
            'apl-9': ArticlePageAPL9,
            'dfb-1': ArticlePageDFB1,
            'dfb-2': ArticlePageDFB2,
            'dfb-3': ArticlePageDFB3,
            'dfb-4': ArticlePageDFB4,
            'dfb-5': ArticlePageDFB5,
            'dfb-6': ArticlePageDFB6,
            'dfb-7': ArticlePageDFB7,
            'dfb-8': ArticlePageDFB8,
            'dfb-9': ArticlePageDFB9,
            'ligaf-1': ArticlePageLIGAF1,
            'ligaf-2': ArticlePageLIGAF2,
            'ligaf-3': ArticlePageLIGAF3,
            'ligaf-4': ArticlePageLIGAF4,
            'ligaf-5': ArticlePageLIGAF5,
            'ligaf-6': ArticlePageLIGAF6,
            'ligaf-7': ArticlePageLIGAF7,
            'ligaf-8': ArticlePageLIGAF8,
            'ligaf-9': ArticlePageLIGAF9,
            'seriea-1': ArticlePageSERIEA1,
            'seriea-2': ArticlePageSERIEA2,
            'seriea-3': ArticlePageSERIEA3,
            'seriea-4': ArticlePageSERIEA4,
            'seriea-5': ArticlePageSERIEA5,
            'seriea-6': ArticlePageSERIEA6,
            'seriea-7': ArticlePageSERIEA7,
            'seriea-8': ArticlePageSERIEA8,
            'seriea-9': ArticlePageSERIEA9,
            'wk-1': ArticlePageWK1,
            'wk-2': ArticlePageWK2,
            'wk-3': ArticlePageWK3,
            'wk-4': ArticlePageWK4,
            'wk-5': ArticlePageWK5,
            'wk-6': ArticlePageWK6,
            'wk-7': ArticlePageWK7,
            'wk-8': ArticlePageWK8,
            'wk-9': ArticlePageWK9,
            'bpi-1': ArticlePageBPI1,
            'bpi-2': ArticlePageBPI2,
            'bpi-3': ArticlePageBPI3,
            'bpi-4': ArticlePageBPI4,
            'bpi-5': ArticlePageBPI5,
            'bpi-6': ArticlePageBPI6,
            'bpi-7': ArticlePageBPI7,
            'bpi-8': ArticlePageBPI8,
            'bpi-9': ArticlePageBPI9,
            'brasil-1': ArticlePageBRASIL1,
            'brasil-2': ArticlePageBRASIL2,
            'brasil-3': ArticlePageBRASIL3,
            'brasil-4': ArticlePageBRASIL4,
            'brasil-5': ArticlePageBRASIL5,
            'brasil-6': ArticlePageBRASIL6,
            'brasil-7': ArticlePageBRASIL7,
            'brasil-8': ArticlePageBRASIL8,
            'brasil-9': ArticlePageBRASIL9,
            'ligamx-1': ArticlePageLIGAMX1,
            'ligamx-2': ArticlePageLIGAMX2,
            'ligamx-3': ArticlePageLIGAMX3,
            'ligamx-4': ArticlePageLIGAMX4,
            'ligamx-5': ArticlePageLIGAMX5,
            'ligamx-6': ArticlePageLIGAMX6,
            'ligamx-7': ArticlePageLIGAMX7,
            'ligamx-8': ArticlePageLIGAMX8,
            'ligamx-9': ArticlePageLIGAMX9,
            'nwfl-1': ArticlePageNWFL1,
            'nwfl-2': ArticlePageNWFL2,
            'nwfl-3': ArticlePageNWFL3,
            'nwfl-4': ArticlePageNWFL4,
            'nwfl-5': ArticlePageNWFL5,
            'nwfl-6': ArticlePageNWFL6,
            'nwfl-7': ArticlePageNWFL7,
            'nwfl-8': ArticlePageNWFL8,
            'nwfl-9': ArticlePageNWFL9,
            'usl-1': ArticlePageUSL1,
            'usl-2': ArticlePageUSL2,
            'usl-3': ArticlePageUSL3,
            'usl-4': ArticlePageUSL4,
            'usl-5': ArticlePageUSL5,
            'usl-6': ArticlePageUSL6,
            'usl-7': ArticlePageUSL7,
            'usl-8': ArticlePageUSL8,
            'usl-9': ArticlePageUSL9,
            'we-1': ArticlePageWE1,
            'we-2': ArticlePageWE2,
            'we-3': ArticlePageWE3,
            'we-4': ArticlePageWE4,
            'we-5': ArticlePageWE5,
            'we-6': ArticlePageWE6,
            'we-7': ArticlePageWE7,
            'we-8': ArticlePageWE8,
            'we-9': ArticlePageWE9,
            'saff-1': ArticlePageSAFF1,
            'saff-2': ArticlePageSAFF2,
            'saff-3': ArticlePageSAFF3,
            'saff-4': ArticlePageSAFF4,
            'saff-5': ArticlePageSAFF5,
            'saff-6': ArticlePageSAFF6,
            'saff-7': ArticlePageSAFF7,
            'saff-8': ArticlePageSAFF8,
            'saff-9': ArticlePageSAFF9,
            'sweden-1': ArticlePageSWEDEN1,
            'sweden-2': ArticlePageSWEDEN2,
            'sweden-3': ArticlePageSWEDEN3,
            'sweden-4': ArticlePageSWEDEN4,
            'sweden-5': ArticlePageSWEDEN5,
            'sweden-6': ArticlePageSWEDEN6,
            'sweden-7': ArticlePageSWEDEN7,
            'sweden-8': ArticlePageSWEDEN8,
            'sweden-9': ArticlePageSWEDEN9,
            'aleague-1': ArticlePageALEAGUE1,
            'aleague-2': ArticlePageALEAGUE2,
            'aleague-3': ArticlePageALEAGUE3,
            'aleague-4': ArticlePageALEAGUE4,
            'aleague-5': ArticlePageALEAGUE5,
            'aleague-6': ArticlePageALEAGUE6,
            'aleague-7': ArticlePageALEAGUE7,
            'aleague-8': ArticlePageALEAGUE8,
            'aleague-9': ArticlePageALEAGUE9,
            'world-1': ArticlePageWORLD1,
            'world-2': ArticlePageWORLD2,
            'world-3': ArticlePageWORLD3,
            'world-4': ArticlePageWORLD4,
            'world-5': ArticlePageWORLD5,
            'world-6': ArticlePageWORLD6,
            'world-7': ArticlePageWORLD7,
            'world-8': ArticlePageWORLD8,
            'world-9': ArticlePageWORLD9
        };

        const ArticleClass = articleMap[id];
        
        if (ArticleClass) {
            const article = new ArticleClass('app-content');
            article.init();
            window.scrollTo(0, 0);
        }
    }

    /**
     * Get component instances (for debugging or external access)
     * In React: Components would be accessible via refs or context
     */
    getComponents() {
        return {
            sidebar: this.sidebar,
            topNav: this.topNav,
            contentArea: this.contentArea
        };
    }
}

// Initialize app when DOM is ready
// In React: This would be ReactDOM.render(<App />, document.getElementById('root'))
function initializeApp() {
    console.log('🚀 initializeApp() called');
    const app = new App();
    console.log('✅ App instance created');
    
    app.init().catch(error => {
        console.error('❌ App initialization failed:', error);
        console.error('Error details:', error);
        // Show error in UI
        const errorDiv = document.getElementById('error-message');
        if (errorDiv) {
            errorDiv.style.display = 'block';
            errorDiv.style.background = '#fee';
            errorDiv.style.borderColor = '#f00';
            errorDiv.innerHTML = `
                <h2>⚠️ Initialization Error</h2>
                <p><strong>Error:</strong> ${error.message}</p>
                <p>Check console for details.</p>
            `;
        }
    });
    
    // Expose app instance globally for debugging (optional)
    // In production React app, this wouldn't be necessary
    window.app = app;
}

// Check if DOM is already loaded
if (document.readyState === 'loading') {
    console.log('📋 DOM is still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    console.log('✅ DOM is already loaded, initializing immediately...');
    // DOM is already loaded, initialize immediately
    initializeApp();
}